module.exports = __webpack_public_path__ + "static/media/W19-0046_299_Mama_Cheese_Mobile_767x845_en.340f125d.jpg";